<template>
<v-card>
    <v-card-text>
        <JuegoSet/>
    </v-card-text>
</v-card>
</template>
<script>
import JuegoSet from './juego-set';

export default {
    components: {
        JuegoSet,
    }
}
</script>